<template>
  <div>
    <div class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1 class="m-0">Download History</h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item"><a href="#">Home</a></li>
              <li class="breadcrumb-item active">
                <a href="/download-history">Download History</a>
              </li>
            </ol>
          </div>
        </div>
      </div>
    </div>

    <div class="content">
      <div class="container-fluid">
        <div class="row justify-content-center">
          <div class="col-md-12">
            <div class="card card-plb">
              <div class="card-header ui-sortable-handle">
                <h5 class="card-title card_title_margin">
                  <i class="nav-icon fa-solid fa-server"></i>
                  Download History
                </h5>
                <div class="card-tools">
                  <button type="button" data-card-widget="collapse" class="btn btn-tool">
                    <i class="fas fa-minus"></i>
                  </button>
                </div>
              </div>
              <div class="card-body">
                <div class="form-group">
                  <div class="vgt-wrap polar-bear">
                    <div class="vgt-inner-wrap">
                      <div class="vgt-global-search vgt-clearfix">
                        <div class="vgt-global-search__input vgt-pull-left">
                          <label>
                            <span aria-hidden="true" class="input__icon">
                              <div class="magnifying-glass"></div>
                            </span>
                            <span class="sr-only"> Search </span>
                          </label>
                          <input type="text" placeholder="Search Data" class="vgt-input vgt-pull-left"
                            v-model="search" />
                        </div>
                        <div class="vgt-global-search__actions vgt-pull-right">
                          <div>
                          </div>
                        </div>
                      </div>
                      <div class="vgt-responsive">
                        <table id="vgt-table" class="vgt-table bordered polar-bear">
                          <thead>
                            <tr>
                              <!-- BEGIN: ID Sort -->
                              <th v-if="order == 'id' && by == 'asc'" @click="sort('id', 'desc')"
                                class="text-center sortable sorting sorting-asc">
                                <span class="table_header">No.</span>
                                <button>
                                  <span class="sr-only"></span>
                                </button>
                              </th>
                              <th v-else-if="order == 'id' && by == 'desc'" @click="sort('id', 'asc')" class="
                                  text-center
                                  sortable
                                  sorting sorting-desc
                                ">
                                <span class="table_header">No.</span>
                                <button>
                                  <span class="sr-only"></span>
                                </button>
                              </th>
                              <th v-else @click="sort('id', 'asc')" class="text-center sortable">
                                <span class="table_header">No.</span>
                                <button>
                                  <span class="sr-only"></span>
                                </button>
                              </th>
                              <!-- END: ID Sort -->
                              <!-- BEGIN: File Name -->
                              <th v-if="order == 'username' && by == 'asc'" @click="sort('username', 'desc')"
                                class="text-center sortable sorting sorting-asc">
                                <span class="table_header">File Name</span>
                                <button>
                                  <span class="sr-only"></span>
                                </button>
                              </th>
                              <th v-else-if="order == 'username' && by == 'desc'" @click="sort('created_at', 'desc')"
                                class="
                                  text-center
                                  sortable
                                  sorting sorting-desc
                                ">
                                <span class="table_header">File Name</span>
                                <button>
                                  <span class="sr-only"></span>
                                </button>
                              </th>
                              <th v-else @click="sort('username', 'asc')" class="text-center sortable">
                                <span class="table_header">File Name</span>
                                <button>
                                  <span class="sr-only"></span>
                                </button>
                              </th>
                              <!-- END: File Name -->

                              <!-- BEGIN: Module -->
                              <th v-if="order == 'username' && by == 'asc'" @click="sort('username', 'desc')"
                                class="text-center sortable sorting sorting-asc">
                                <span class="table_header">Module</span>
                                <button>
                                  <span class="sr-only"></span>
                                </button>
                              </th>
                              <th v-else-if="order == 'username' && by == 'desc'" @click="sort('created_at', 'desc')"
                                class="
                                  text-center
                                  sortable
                                  sorting sorting-desc
                                ">
                                <span class="table_header">Module</span>
                                <button>
                                  <span class="sr-only"></span>
                                </button>
                              </th>
                              <th v-else @click="sort('username', 'asc')" class="text-center sortable">
                                <span class="table_header">Module</span>
                                <button>
                                  <span class="sr-only"></span>
                                </button>
                              </th>
                              <!-- END: Module -->
                              <!-- BEGIN: Created At  -->
                              <th v-if="order == 'last_login_at' && by == 'asc'" @click="sort('last_login_at', 'desc')"
                                class="text-center sortable sorting sorting-asc">
                                <span class="table_header">Created At</span>
                                <button>
                                  <span class="sr-only"></span>
                                </button>
                              </th>
                              <th v-else-if="
                                order == 'last_login_at' && by == 'desc'
                              " @click="sort('created_at', 'desc')" class="
                                  text-center
                                  sortable
                                  sorting sorting-desc
                                ">
                                <span class="table_header">Created At</span>
                                <button>
                                  <span class="sr-only"></span>
                                </button>
                              </th>
                              <th v-else @click="sort('last_login_at', 'asc')" class="text-center sortable">
                                <span class="table_header">Created At</span>
                                <button>
                                  <span class="sr-only"></span>
                                </button>
                              </th>
                              <!-- END: Created At -->
                              <th class="text-center sortable">
                                <span class="table_header">Action</span>
                              </th>
                            </tr>
                            <tr>
                              <th class="filter-th"></th>
                              <th class="filter-th">
                                <div>
                                  <input type="text" class="vgt-input text-center" placeholder="Search File Name"
                                    v-model="search_file_name" />
                                </div>
                              </th>
                              <th class="filter-th">
                                <div>
                                  <input type="text" class="vgt-input text-center" placeholder="Search Module"
                                    v-model="search_module" />
                                </div>
                              </th>
                              <th class="filter-th">
                                <div>
                                  <input type="date" class="vgt-input text-center" v-model="search_created_at" />
                                </div>
                              </th>
                              <th class="filter-th"></th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="(download, downloads_index) in download_history.data" :key="downloads_index">
                              <td class="text-center table_content">
                                {{ ((current_page - 1) * paginate) + downloads_index + 1 }}
                              </td>
                              <td class="text-center table_content">
                                {{ download.file_name }}
                              </td>
                              <td class="text-center table_content">
                                {{ download.module }}
                              </td>
                              <td class="text-center table_content">
                                {{ download.created_at | myDateTime }}
                              </td>
                              <td class="text-center table_content">
                                  <button 
                                        v-if="download.status === 'completed'"
                                        class="btn btn-success btn-sm"
                                        @click="downloadExportedJob(download.id)"
                                        title="Download file"
                                    >
                                        <i class="nav-icon fa-solid fa-cloud-arrow-down"></i>
                                        Download
                                    </button>
                                    
                                    <button 
                                        v-else-if="download.status === 'processing'"
                                        class="btn btn-warning btn-sm"
                                        disabled
                                        title="Sedang diproses"
                                    >
                                        <i class="nav-icon fa-solid fa-spinner fa-spin"></i>
                                        Processing
                                    </button>
                                    
                                    <button 
                                        v-else-if="download.status === 'pending'"
                                        class="btn btn-info btn-sm"
                                        disabled
                                        title="Menunggu diproses"
                                    >
                                        <i class="nav-icon fa-solid fa-clock"></i>
                                        Pending
                                    </button>
                                    
                                    <button 
                                        v-else-if="download.status === 'failed'"
                                        class="btn btn-danger btn-sm"
                                        disabled
                                        :title="download.error_message || 'Gagal diproses'"
                                    >
                                        <i class="nav-icon fa-solid fa-exclamation-triangle"></i>
                                        Failed
                                    </button>
                              </td>
                            </tr>
                            <tr v-if="download_history.data.length < 1">
                              <td colspan="8">
                                <div class="vgt-center-align vgt-text-disabled">
                                  Data not found
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <div class="vgt-wrap__footer vgt-clearfix">
                        <div class="footer__row-count vgt-pull-left">
                          <label class="footer__row-count__label row_per_page_label">
                            Rows per page:
                          </label>
                          <select class="
                              footer__row-count__select
                              row_per_page_option
                            " v-model="paginate" @change="list()">
                            <option value="10">10</option>
                            <option value="25">25</option>
                            <option value="50">50</option>
                            <option value="100">100</option>
                          </select>
                        </div>
                        <div class="footer__navigation vgt-pull-right">
                          <button type="button" class="footer__navigation__page-btn" :class="{
                            disabled: !download_history.prev_page_url,
                          }" @click="
  download_history.prev_page_url &&
  list(download_history.prev_page_url)
" style="margin-right: 0px">
                            <span aria-hidden="true" class="chevron left"></span>
                            <span class="paginate_text">Prev</span>
                          </button>
                          <div class="footer__navigation__page-info" style="color: #99a0b2">
                            <label class="page-info__label" style="margin-bottom: -5px">
                              <span class="paginate_text">page</span>
                              <input type="text" class="
                                  footer__navigation__page-info__current-entry
                                  vgt-input
                                " v-model="current_page" @keypress="directPage" style="width: 60px" />
                              <span class="paginate_text">
                                of
                                {{ download_history.last_page }}
                              </span>
                            </label>
                          </div>
                          <button type="button" class="footer__navigation__page-btn" :class="{
                            disabled: !download_history.next_page_url,
                          }" @click="
  download_history.next_page_url &&
  list(download_history.next_page_url)
">
                            <span style="font-weight: 500">Next</span>
                            <span aria-hidden="true" class="chevron right"></span>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import debounce from "lodash/debounce";
import Swal from "sweetalert2";

export default {
  data() {
    return {
      download_history: {
        data: [],
        links: [],
      },
      // Query Search
      search: null,
      search_file_name: null,
      search_module: null,
      search_created_at: null,

      //  Query Order
      order: "id",
      by: "desc",
      paginate: "10",
      current_page: null,
    };
  },
  created() {
    this.list();
  },
  watch: {
    search: debounce(function () {
      this.list();
    }, 500),
    search_file_name: debounce(function () {
      this.list();
    }, 500),
    search_created_at: debounce(function () {
      this.list();
    }, 500),
  },
  methods: {
    async downloadExportedJob(jobId) {
        try {
        const statusResponse = await axios.get(`/api/customs/outbound-excel/status/${jobId}`);
        
        if (statusResponse.data.status !== 'completed') {
            Swal.fire({
            icon: 'warning',
            title: 'File not ready',
            text: 'File is not ready for download yet. Please try again later.',
            timer: 3000
            });
            return;
        }

        await this.downloadFile(jobId);
        
        } catch (error) {
        console.error('Error downloading file:', error);
        Swal.fire({
            icon: 'error',
            title: 'Download Failed',
            text: 'An error occurred while downloading the file',
            timer: 3000
        });
        }
    },
    async downloadFile(jobId) {
        try {

        Swal.fire({
            title: 'Downloading...',
            text: 'Please wait while the file is being downloaded.',
            allowOutsideClick: false,
            showCancelButton: false,
            showConfirmButton: false,
            didOpen: () => {
                Swal.showLoading();
            }
        });
        const response = await axios({
            method: 'GET',
            url: `/api/job/download/${jobId}`,
            responseType: 'blob',
        });

        if (response.data instanceof Blob) {
            const blob = new Blob([response.data]);
            const url = window.URL.createObjectURL(blob);
            
            const link = document.createElement('a');
            link.href = url;
            
            const contentDisposition = response.headers['content-disposition'];
            let fileName = `export_${jobId}.xlsx`;
            
            if (contentDisposition) {
              const fileNameMatch = contentDisposition.match(/filename="?(.+)"?/);
              if (fileNameMatch.length === 2) {
                  fileName = fileNameMatch[1];
              }
            }
            
            link.setAttribute('download', fileName);
            document.body.appendChild(link);
            link.click();
            link.remove();
            
            window.URL.revokeObjectURL(url);
            
            Swal.close();
            Swal.fire({
              icon: 'success',
              title: 'Download Successful',
              text: 'File has been successfully downloaded',
              timer: 2000,
              showConfirmButton: false
            });
        } else {
            throw new Error('Response is not a Blob');
        }
        
        } catch (error) {
        }
    },
    showLoading() {
      Swal.fire({
        didOpen: () => {
          Swal.showLoading();
        },
        background: "transparent",
        allowOutsideClick: false,
      });
    },
    showSuccessRequest() {
      Swal.fire({
        toast: true,
        position: 'top-end',
        icon: 'success',
        title: 'Successfully Retrieve Data',
        showConfirmButton: false,
        timer: 1500
      })
    },
    showErrorRequest() {
      Swal.fire({
        toast: true,
        position: "top-end",
        icon: "error",
        title: "Failed to Retrieve Data",
        showConfirmButton: false,
        timer: 1500,
      });
    },
    list(paginate) {
      this.showLoading();
      paginate = paginate || `api/job/download/history`;
      axios
        .get(paginate, {
          params: {
            search: this.search,
            search_file_name: this.search_file_name,
            search_created_at: this.search_created_at,
            order: this.order,
            by: this.by,
            paginate: this.paginate,
          },
        })
        .then((response) => {
          this.download_history = response.data;
          this.current_page = this.download_history.current_page;
          Swal.close();
          this.showSuccessRequest();
        })
        .catch((error) => {
          Swal.close();
          this.showErrorRequest();
          console.log(error);
        });
    },
    directPage: debounce(function () {
      if (this.current_page < 1) {
        this.current_page = 1;
      } else if (this.current_page > this.download_history.last_page) {
        this.current_page = this.download_history.last_page;
      }

      let url = new URL(this.download_history.first_page_url);
      let search_params = url.searchParams;
      search_params.set("page", this.current_page);
      url.search = search_params.toString();
      let new_url = url.toString();
      this.list(new_url);
    }, 500),
    sort(order, by) {
      this.order = order;
      this.by = by;
      this.list();
    },
  },
};
</script>
<style scoped>
.vgt-global-search__input .input__icon .magnifying-glass {
  margin-top: -3px;
}
</style>
